<template>
    <el-dialog
    :visible="visible"
    :title="$t('popper_title.jonit_angle')"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    custom-class="codelab-popper joint-angle-popper"
    width="600px"
    @touchmove.prevent.stop
    >
    <div class="popper-top">
        <div>
            <span class="label">{{title}}</span>
            <el-input 
            v-model.number="showValue" 
            :type="isMobile ? 'number' : 'text'"
            @change="onInputChange"
            @focus="onInputFocus"
            ></el-input>
        </div>
        <div>
            <span class="label">{{$t("joint_angle.speed")}}</span>
            <el-slider 
            v-if="speedOptions" 
            v-model="speedIndex" 
            :min="speedOptions[0][1]" 
            :max="speedOptions[speedOptions.length - 1][1]" 
            :step="1" 
            :show-tooltip="false"
            :marks="speedMarkers"
            class="speed-slider"
            ></el-slider>
        </div>
    </div>
    <div  v-if="field && visible" class="container" ref="container" :style="{height: `${bg.height}px`}">
        <div class="bg" :style="bgStyle">
            <img :src="bg.src" :width="bg.width" :height="bg.height">
            <svg class="angle-limiter" :style="{left: `${transform.x}px`, top: `${transform.y}px`}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200" version="1.1" viewBox="0 0 200 200">
                <path fill="rgba(231,231,108,0.6)" :d="limiterPath"></path>
            </svg>
            <div class="symbol" ref="symbol" :style="symbolStyle" @click="onSymbolClick">
                <img :src="symbol" width="200" height="200" alt="" :style="{transform: `rotate(${symbolRotate}deg)`,transformOrigin: `${transform.cx}px ${transform.cy}px`}">
            </div>
        </div>
    </div>
    <div slot="footer" class="footer-button-group">
        <el-button class="codelab-button popper-footer-button gray" @click="close">{{$t("button.cancel")}}</el-button>
        <el-button class="codelab-button popper-footer-button blue" @click="confirm">{{$t("button.ok")}}</el-button>
    </div>
    </el-dialog>
</template>
<script>
import Vue from 'vue'
const isMobile = Vue.prototype.util$.isMobile$();
const dragStart = isMobile ? "touchstart": "mousedown";
const dragMove = isMobile ? "touchmove": "mousemove";
const dragEnd = isMobile ? "touchend" : "mouseup";
export default {
    neme: "joint-angle-popper",
    data(){
        return {
            isMobile,
            field: null,
            showValue: isMobile ? 0 : "0°",
            initValue: 0,
            value: 0,
            angleCenter: [0, 0],
            speedIndex: 0,
            speedOptions: null,
            speedValues: null,
            speedMarkers: null,
            title: ''
        }
    },
    computed: {
        visible(){
            return !!this.field
        },
        symbolStyle(){
            if(!this.field){
                return {};
            }
            
            let {
                x,
                y
            } = this.transform;
            return {
                left: `${x}px`,
                top: `${y}px`
            }
        },
        bgStyle(){
            if(!this.field){
                return {};
            }
            let {
                width,
                height
            } = this.bg;
            return {
                width: `${width}px`,
                height: `${height}px`
            }
        },
        symbolRotate(){
            return (this.value - this.initValue) * this.clockWise;
        },
        limiterPath(){
            const radius = 85;
            const startPoint = this.getPoint(this.initAngle, radius);
            const endAngle = this.symbolRotate + this.initAngle;
            const endPoint = this.getPoint(endAngle, radius);
            const clockWise = endAngle > this.initAngle ? 1 : 0;
            const largeArc = Math.abs(this.symbolRotate) >= 180 ? 1 : 0;
            return `M100,100l${startPoint.join(",")}A${radius},${radius} 0,${largeArc} ${clockWise} ${endPoint[0] + 100},${endPoint[1] + 100}z`;
        },
        speed(){
            if(!this.speedValues){
                return `0`;
            }
            return `${this.speedValues[this.speedIndex] || 0}`;
        }
    },
    methods: {
        close(){
            this.$emit('close')
        },
        confirm(){
            const field = this.field;
            field.setValue.bind(field)(this.value);
            if(field.sourceBlock_){
                const speedField = field.sourceBlock_.getField("input2");
                if(speedField){
                    speedField.setValue(this.speed);
                }
            }
            this.close();
        },
        setField(field){
            this.field = field
            if(field.sourceBlock_ && field.sourceBlock_.type){
                this.title = this.$t(`popper_title.joint.${field.sourceBlock_.type}`)
            } else {
                this.title = ''
            }
            Object.keys(field.fieldoptions).forEach(key => {
                if(key === 'clockWise'){
                    if(typeof field.fieldoptions.clockWise === 'function'){
                        this.clockWise = field.fieldoptions.clockWise(field)
                    } else {
                        this.clockWise = field.fieldoptions.clockWise
                    }
                } else if(key === 'title'){
                        if(typeof field.fieldoptions.title === 'function'){
                        this.title = field.fieldoptions.title(field)
                    } else {
                        this.title = field.fieldoptions.title || ''
                    }
                } else {
                    this[key] = field.fieldoptions[key];
                }
            });
            this.initValue = field.initValue;
            this.setValue(field.value_)
            if(field.sourceBlock_){
                const speedField = field.sourceBlock_.getField("input2");
                if(speedField){
                    let speedValue = speedField.getValue();
                    let speedOptions = speedField.getOptions();
                    let speedMarkers = {};
                    let speedValues = [];
                    this.speedIndex = speedOptions.findIndex(item => item[1] === speedValue);
                    speedOptions = speedOptions.map((item, index) => {
                        speedMarkers[index] = item[0];
                        speedValues.push(Number(item[1]));
                        return [item[0], index]
                    })
                    this.speedMarkers = speedMarkers;
                    this.speedValues = speedValues;
                    this.speedOptions = speedOptions;
                }
            }
            this.$nextTick(() => {
                this.bindSymbolEvents();
            })
        },
        setValue(value){
            this.value = value
            this.showValue = isMobile ? Number(this.getLabel(value)): `${this.getLabel(value)}°`;
        },
        bindSymbolEvents(){
            if(!this.$refs.symbol){
                return;
            }
            const symbol = this.$refs.symbol;
            symbol.addEventListener(dragStart, this.onDragStart);
        },
        unBindSymbolEvents(){
            if(!this.$refs.symbol){
                return;
            }
            const symbol = this.$refs.symbol;
            symbol.removeEventListener(dragStart, this.onDragStart);
        },
        onDragStart(e){
            this.lockSymbolClick = false;
            this.updateAngleCenter();
            const {clientX, clientY} = this.getDragPosition(e);
            this.dragStartValue = this.value;
            this.dragStartX = clientX;
            this.dragStartY = clientY;
            const symbol = isMobile ? this.$refs.symbol : this.$refs.container;
            symbol.addEventListener(dragMove, this.onDragMove);
            symbol.addEventListener(dragEnd, this.onDragEnd);
            if(!isMobile){
                symbol.addEventListener("mouseleave" ,this.onDragEnd);
            }
        },
        onDragMove(e){
            e.stopPropagation();
            e.preventDefault();
            if(!this.lockSymbolClick){
                setTimeout(() => {
                    this.lockSymbolClick = true;
                }, 200);
            }
            const {clientX, clientY} = this.getDragPosition(e);
            const [centerX , centerY] = this.angleCenter;
            let dAngle = this.getDAngle(this.dragStartX - centerX, this.dragStartY - centerY, clientX - centerX, clientY - centerY);
            this.dragStartX = clientX;
            this.dragStartY = clientY;
            const oldValue = Number(this.value);
            let value = this.validateValue(Math.round(oldValue + dAngle * this.clockWise))
            this.setValue(value)
        },
        onDragEnd(){
            setTimeout(() => {
                this.lockSymbolClick = false;
            }, 200);
            const symbol = isMobile ? this.$refs.symbol : this.$refs.container;
            symbol.removeEventListener(dragMove, this.onDragMove);
            symbol.removeEventListener(dragEnd ,this.onDragEnd);
            if(!isMobile){
                symbol.removeEventListener("mouseleave" ,this.onDragEnd);
            }
        },
        updateAngleCenter(){
            const symbol = this.$refs.symbol;
            const bounding = symbol.getBoundingClientRect();
            const {
                cx,
                cy
            } = this.transform;
            this.angleCenter = [bounding.left + cx, bounding.top + cy];
        },
        onSymbolClick(e) {
            e.stopPropagation();
            if(this.lockSymbolClick){
                return;
            }
            this.updateAngleCenter();
            let { clientX, clientY } = e;
            let angleCenter = this.angleCenter;
            let clickAngle = this.getAngle(clientX - angleCenter[0], clientY - angleCenter[1]);
            clickAngle = clickAngle - this.initAngle
            if(clickAngle < 0){
                clickAngle += 360
            }
            if(this.clockWise === -1){
                clickAngle = 360 - clickAngle
            }
            
            let pixel = 5;
            let value = Math.round(clickAngle / pixel) * pixel + this.initValue;
            if(value < this.min || value > this.max){
                if(value > this.max){
                    if(value - 360 >= this.min && value - 360 <= this.max){
                        value = value - 360
                    } else {
                        if(Math.abs(value - this.max) <= pixel){
                            value = this.max
                        } else {
                            if(Math.abs(value - 360 - this.max) <= pixel){
                                value = this.max
                            } else if(Math.abs(value - 360 - this.min) <= pixel){
                                value = this.min
                            } else {
                                return
                            }
                        }
                    }
                } else if(value < this.min){
                    if(value + 360 >= this.min && value + 360 <= this.max){
                        value += 360
                    } else {
                        if(Math.abs(value - this.min) <= pixel){
                            value = this.min
                        } else {
                            if(Math.abs(value + 360 - this.min) <= pixel){
                                value = this.min
                            } else if(Math.abs(value + 360 - this.max) <= pixel){
                                value = this.max
                            } else {
                                return
                            }
                        }
                    }
                }
            }
            this.setValue(value)
        },
        //计算一个点的与旋转中心连线的与x轴正方向的夹角
        getAngle(x, y) {
            if (x === 0) {
                if (y >= 0) {
                    return 90;
                } else {
                    return 270;
                }
            }
            let angle = Math.atan(y / x);
            angle = angle * 180 / Math.PI;
            if (x < 0) {
                angle = 180 + angle;
            } else if (y < 0) {
                angle += 360;
            }
            return angle;
        },
        //计算两点与旋转中心的夹角
        getDAngle(x1, y1, x2, y2) {
            let angle1 = this.getAngle(x1, y1);
            let angle2 = this.getAngle(x2, y2);
            let dAngle = angle2 - angle1;
            if (angle1 > 270 && angle1 <= 360) {
                if (angle2 >= 0 && angle2 < 90) {
                    dAngle = angle2 - angle1 + 360;
                }
            } else if (angle1 >= 0 && angle1 < 90) {
                if (angle2 > 270 && angle2 <= 360) {
                    dAngle = angle2 - angle1 - 360;
                }
            }
            return dAngle;
        },
        //获取半径为radius的圆弧上，与x轴正方向角度为angle的点的坐标
        getPoint(angle, radius) {
            let rad = angle * Math.PI / 180;
            let x = Math.cos(rad) * radius;
            let y = Math.sin(rad) * radius;
            return [x, y];
        },
        //校驗值
        validateValue(value){
            const {min, max} = this;
            value === null && (value = 0);
            value = Number(value);
            isNaN(value) && (value = 0);
            value %= 360;
            value < min && (value = min);
            value > max && (value = max);
            return value;
        },
        getDragPosition(e){
            let {
                clientX,
                clientY
            } = e;
            if(e.touches){
                clientX = e.touches[0].clientX;
                clientY = e.touches[0].clientY;
            }
            return {
                clientX,
                clientY
            }
        },
        onInputChange(value){
            value = Number(value);
            if(isNaN(value)){
                this.setValue(this.value)
                return;
            }
            value = this.fixInputValue(value);
            value > this.max && (value = this.max)
            value < this.min && (value = this.min)
            value = this.validateValue(value);
            this.setValue(value)
        },
        onInputFocus(e){
            this.$nextTick(() => {
                const target = e.target;
                const originType = target.type;
                target.type = "text";
                target.selectionStart = 0;
                target.selectionEnd = target.value.length - 1;
                target.type = originType;
            });
        }
    },
    destroyed(){
        this.unBindSymbolEvents()
    }
}
</script>
<style lang="scss">
.joint-angle-popper.el-dialog{
    .el-dialog__body{
        padding: 0 30px;
    }
    .popper-top{
        padding: 20px 0;
        width: 100%;
        line-height: 60px;
        text-align: left;
        font-size: 20px;
        &>div{
            height: 40px;
            padding: 0 24px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .label{
            vertical-align: middle;
            color: #ffffff;
            flex: 0 0 auto;
        }
        .el-input{
            width: 72px;
            height: 32px;
            background: #B4B4B4;
            border-radius: 4px;
            overflow: hidden;
            margin-left: 18px;
            font-size: 0;
            line-height: 0;
            vertical-align: middle;
            flex: 0 1 auto;
            .el-input__inner{
                color: #4a4a4a;
                border: none;
                outline: none;
                background: transparent;
                font-size: 18px;
            }
        }
        .speed-slider{
            width: 100%;
            margin: 0 24px;
            flex: 0 1 auto;
            .el-slider__runway{
                background-color: #666666;
            }
            .el-slider__bar{
                background-color: #cacaca;
            }
            .el-slider__marks{
                .el-slider__marks-text{
                    color: #a8a8ac;
                    white-space: nowrap;
                    line-height: 24px;
                }
            }
        }
    }
    .container{
        width: 100%;
        min-height: 240px;
        max-height: 320px;
        margin-top: 30px;
        overflow: hidden;
        position: relative;
        .bg{
            width: 100%;
            height: 100%;
            margin: 0 auto;
            font-size: 0;
            line-height: 0;
            position: relative;
            // left: 50%;
            // top: 50%;
            img{
                pointer-events: none;
            }
            .symbol{
                width: 200px;
                height: 200px;
                display: inline-block;
                position: absolute;
                font-size: 0;
                line-height: 0;
                cursor: pointer;
                z-index: 1;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .angle-limiter{
                position: absolute;
                left: 0;
                top: 0;
                pointer-events: none;
            }
        }
    }
    .footer-button-group{
        .popper-footer-button{
            border-color: transparent;
        }
    }
}
</style>